import { createSlice } from '@reduxjs/toolkit';
import { shuffle, createGrid, incrementGrid, decrementGrid, testCode, resultTest } from '../client/components/utils';
import _ from 'lodash';

export const challengeSlice = createSlice({
  name: 'challenge',
  initialState: {
    codeArray: shuffle(),
    gridArray: createGrid(),
    incrementGridArray: [],
    decrementGridArray: [],
    rightSwipes: 0,
    leftSwipes: 0,
    clickCount: 0,
    testCodeArray: [],
    codeNumber: null,
    isReviewing: false,
    isGrid: false,
    patternCount: 0,
    registeredPattern: [],
    selectedCell: null,
    signinResult: null,
    isTest: false,
  },
  reducers: {
    codeArray: (state, action) => {
      state.codeArray = action.payload;
    },
    gridArray: (state, action) => {
      state.gridArray = action.payload;
    },
    incrementGridArray: (state, action) => {
      state.incrementGridArray = incrementGrid(state.gridArray);
    },
    decrementGridArray: (state, action) => {
      state.decrementGridArray = decrementGrid(state.gridArray);
    },
    rightSwipeIncrement: (state, action) => {
      state.rightSwipes += 1;
    },
    leftSwipeIncrement: (state, action) => {
      state.leftSwipes += 1;
    },
    isReviewing: (state, action) => {
      state.isReviewing = action.payload;
    },
    isGrid: (state, action) => {
      state.isGrid = action.payload;
    },
    patternCount: (state, action) => {
      state.patternCount = action.payload;
    },
    registeredPattern: (state, action) => {
      state.registeredPattern = action.payload;
    },
    selectedCell: (state, action) => {
      state.selectedCell = action.payload;
    },
    signinResult: (state, action) => {
      state.signinResult = action.payload;
    },
    clickCount: (state, action) => {
      state.clickCount += 1;
      let tmpRegisteredPattern = _.cloneDeep(state.registeredPattern);
      let cellValue = testCode(state.clickCount, state.gridArray, state.selectedCell, tmpRegisteredPattern);
      state.testCodeArray = [...state.testCodeArray, cellValue];
      if (state.clickCount == 6) {
        let tmpCodeArray = _.cloneDeep(state.codeArray);
        let answer = resultTest(state.testCodeArray, state.selectedCell, tmpCodeArray);
        state.signinResult = answer;
        if (answer == true) {
          state.codeNumber = state.testCodeArray[state.selectedCell];
        } else {
          state.codeNumber = 666;
        }
      }
    },
    undoCount: (state) => {
      state.clickCount -= 1;
      let tmpCodeArray = _.cloneDeep(state.testCodeArray);
      console.log('testCodeArray before pop: ', tmpCodeArray);
      tmpCodeArray.pop();
      console.log('testCodeArray after pop: ', tmpCodeArray);
      state.testCodeArray = tmpCodeArray;
    },
    resetPattern: (state) => {
      let tmpRegisteredPattern = _.cloneDeep(state.registeredPattern);
      tmpRegisteredPattern = [];
      state.registeredPattern = tmpRegisteredPattern;
    },
    resetTestCodeArray: (state, action) => {
      state.testCodeArray = action.payload;
    },
    resetCodeNumber: (state, action) => {
      state.codeNumber = action.payload;
    },
    resetClickCount: (state, action) => {
      state.clickCount = action.payload;
    },
    isTest: (state, action) => {
      state.isTest = action.payload;
    },
    setTestCode: (state, action) => {
      // let tmpCodeArray = _.cloneDeep(state.testCodeArray);
      state.testCodeArray = [...state.testCodeArray, action.payload];
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  codeArray,
  gridArray,
  incrementGridArray,
  decrementGridArray,
  rightSwipeIncrement,
  leftSwipeIncrement,
  clickCount,
  undoCount,
  codeNumber,
  isReviewing,
  isGrid,
  patternCount,
  registeredPattern,
  resetPattern,
  selectedCell,
  signinResult,
  resetTestCodeArray,
  resetCodeNumber,
  resetClickCount,
  isTest,
  setTestCode,
} = challengeSlice.actions;

export default challengeSlice.reducer;